import React from "react";
import { NavigationItem } from "~assets/frontend/frame/frm-navigation/components/NavigationItem";
export const NavigationSection = (props) => {
    return (React.createElement("ul", { className: props.className }, props.items.map((navItem) => {
        return (React.createElement(NavigationItem, Object.assign({ key: navItem.locationId }, navItem, { onSelect: () => {
                props.onSelect(navItem.locationId);
            }, layer: props.layer, onDetail: props.onDetail, selectedLocation: props.selectedLocation })));
    })));
};
